import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { GoogleAutocompleteMap } from 'components/@shared/GoogleAutocompleteMap';

interface Props {
    address: string;
    placeId: string;
}

export const AppointmentDetailsAddress = ({ address, placeId }: Props) => {
    return (
        <Grid container>
            <Grid item xs={4} lg={3}>
                <Typography fontWeight={500}>Address</Typography>
            </Grid>
            <Grid item xs={8} lg={9}>
                <Typography>{address}</Typography>
                <GoogleAutocompleteMap placeId={placeId} />
            </Grid>
        </Grid>
    );
};
